import {
  FORM_DOCUMENT_ADD_NEW,
  FORM_DOCUMENT_ADD_NEW_SUCCESS,
  FORM_DOCUMENT_ADD_NEW_ERROR,
  FORM_DOCUMENT_DELETE,
  FORM_DOCUMENT_DELETE_ERROR,
  FORM_DOCUMENT_DELETE_SUCCESS,
  FORM_DOCUMENT_EDIT,
  FORM_DOCUMENT_EDIT_ERROR,
  FORM_DOCUMENT_EDIT_SUCCESS,
  FORM_DOCUMENT_GET_BY_ID,
  FORM_DOCUMENT_GET_BY_ID_ERROR,
  FORM_DOCUMENT_GET_BY_ID_SUCCESS,
  FORM_DOCUMENT_GET_LIST,
  FORM_DOCUMENT_GET_LIST_ERROR,
  FORM_DOCUMENT_GET_LIST_SUCCESS,
  FORM_DOCUMENT_ADD_NEW_REQUEST,
} from '../actions';

const initialState = {
  items: [],
  item: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FORM_DOCUMENT_GET_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case FORM_DOCUMENT_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case FORM_DOCUMENT_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case FORM_DOCUMENT_GET_LIST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case FORM_DOCUMENT_GET_LIST_SUCCESS:
      return {
        ...state,
        items: payload,
        loading: false,
      };
    case FORM_DOCUMENT_ADD_NEW:
      return {
        ...state,
        loading: true,
        error: null,
        addSuccess: false,
      };

    case FORM_DOCUMENT_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
        items: state.items.concat(payload),
        addSuccess: true,
      };

    case FORM_DOCUMENT_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case FORM_DOCUMENT_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        item: payload,
        error: null,
        editSuccess: true,
      };
    case FORM_DOCUMENT_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: false,
      };
    case FORM_DOCUMENT_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(c => c.id !== payload),
        deleteSuccess: true,
      };
    case FORM_DOCUMENT_DELETE_ERROR:
    case FORM_DOCUMENT_ADD_NEW_ERROR:
    case FORM_DOCUMENT_EDIT_ERROR:
    case FORM_DOCUMENT_GET_BY_ID_ERROR:
    case FORM_DOCUMENT_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
